import * as React from 'react';
import './notFoundPage.css'

const notFoundPage = (props: any) => {

    return (
        <div id={'notfound-wrapper'} style={{backgroundColor: '#2D3436', height: '100%'}}>
            <header style={{height: 50, display: "flex"}} className="bo-core-header top-header">
                <div style={{
                    float: "left",
                    paddingLeft: 4,
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center"
                }}>
                </div>
            </header>
            <div className="notfound-container">
                <div id={'notfound'}>
                    <div className={'notfound'}>
                        <div className="notfound-404">
                            <h1>404</h1>
                        </div>
                        <h2>WE ARE SORRY, PAGE NOT FOUND!</h2>
                        <p>THE PAGE YOU ARE LOOKING FOR MIGHT HAVE BEEN REMOVED HAD ITS NAME CHANGED OR IS TEMPORARILY UNAVAILABLE.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default notFoundPage;




// WEBPACK FOOTER //
// ./app/views/bo-core/notFound/NotFoundPage.tsx